/** Human-readable labels for known compliance document categories. */
export const FILE_CONTENT_TYPE_LABELS = {
  subprocessor_list: 'Subprocessor list',
  privacy_policy: 'Privacy policy',
  audit_report: 'Audit report',
  dpa: 'Data processing agreement',
  terms_of_service: 'Terms of service',
  cookie_policy: 'Cookie policy',
  soc2_report: 'SOC 2 report',
  iso27001_certificate: 'ISO 27001 certificate',
  penetration_test_report: 'Penetration test report',
  security_whitepaper: 'Security whitepaper',
}

/**
 * Material / MUI-style icons for file formats (Quasar `q-icon` names).
 * Keys are normalized extensions without a leading dot.
 */
export const FILE_FORMAT_ICONS = {
  pdf: 'picture_as_pdf',
  doc: 'description',
  docx: 'description',
  xls: 'table_chart',
  xlsx: 'table_chart',
  csv: 'table_rows',
  txt: 'article',
  ppt: 'slideshow',
  pptx: 'slideshow',
  zip: 'folder_zip',
  rar: 'folder_zip',
  '7z': 'folder_zip',
  png: 'image',
  jpg: 'image',
  jpeg: 'image',
  gif: 'image',
  webp: 'image',
  svg: 'image',
  html: 'html',
  htm: 'html',
  json: 'data_object',
  xml: 'code',
}

export const DEFAULT_FILE_FORMAT_ICON = 'insert_drive_file'

/** MIME substring → extension key for icon lookup when `file_type` is missing. */
export const FILE_MIME_FORMAT_KEYS = {
  pdf: 'pdf',
  spreadsheet: 'xlsx',
  excel: 'xlsx',
  csv: 'csv',
  'text/plain': 'txt',
  msword: 'doc',
  wordprocessingml: 'docx',
  presentation: 'pptx',
  zip: 'zip',
  png: 'png',
  jpeg: 'jpg',
  gif: 'gif',
  webp: 'webp',
  svg: 'svg',
  html: 'html',
  json: 'json',
  xml: 'xml',
}

export const COMPANY_FILES_TABLE_COLUMNS = [
  {
    name: 'document',
    required: true,
    label: 'Document',
    align: 'left',
    field: 'fileName',
    sortable: true,
  },
  {
    name: 'active',
    label: 'Status',
    align: 'center',
    field: 'active',
    sortable: true,
    style: 'width: 7rem',
    headerStyle: 'width: 7rem',
  },
  {
    name: 'uploadTime',
    label: 'Uploaded',
    align: 'right',
    field: 'uploadTime',
    sortable: true,
    style: 'width: 8rem; padding-inline-end: 0.25rem !important;',
    headerStyle: 'width: 8rem; padding-inline-end: 0.25rem !important;',
  },
  {
    name: 'actions',
    required: true,
    label: '',
    align: 'center',
    field: 'fileId',
    sortable: false,
    style: 'width: 2.75rem',
    headerStyle: 'width: 2.75rem',
  },
]

export const COMPANY_FILES_TABLE_PAGINATION = {
  page: 1,
  rowsPerPage: 25,
  rowsPerPageOptions: [10, 25, 50],
  sortBy: 'uploadTime',
  descending: true,
}
